import * as React from 'react'
import { cn } from '../../lib/utils'

export interface SwitchFormProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const SwitchForm = React.forwardRef<HTMLInputElement, SwitchFormProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        type="checkbox"
        role="switch"
        className={cn(
          'relative h-6 w-[44px] min-w-[44px] flex-shrink-0 appearance-none rounded-full bg-gray-200 transition-colors duration-200 before:absolute before:left-[2px] before:top-[2px] before:h-5 before:w-5 before:rounded-full before:bg-white before:transition-transform before:duration-200 checked:bg-admin-blue checked:before:translate-x-5 focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-2',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
SwitchForm.displayName = 'SwitchForm'

export { SwitchForm }
